"use strict";
// List of available module types - these constants are supposed to be used everywhere in the code
Object.defineProperty(exports, "__esModule", { value: true });
exports.moduleList = exports.moduleNlt = exports.moduleOpt = exports.moduleBc = exports.moduleTypeValues = exports.moduleType = void 0;
exports.moduleType = {
    BINARY_NUMERICAL: 'binary-numerical',
    NATURAL_LANGUAGE_TAGGING: 'natural-language-tagging',
    CAMPAIGN_OPTIMIZATION: 'campaign-optimization',
};
exports.moduleTypeValues = Object.values(exports.moduleType);
// Detailed description of the modules listed above.
exports.moduleBc = {
    type: exports.moduleType.BINARY_NUMERICAL,
    name: 'Binary Classification',
    shortName: 'nbc',
    available: true,
    iconClassName: 'icon-binary-numerical',
};
exports.moduleOpt = {
    type: exports.moduleType.CAMPAIGN_OPTIMIZATION,
    name: 'Campaign Optimization',
    shortName: 'opt',
    available: true,
    iconClassName: 'icon-optimization',
};
exports.moduleNlt = {
    type: exports.moduleType.NATURAL_LANGUAGE_TAGGING,
    name: 'Natural Language Tagging',
    shortName: 'nlt',
    available: true,
    iconClassName: 'icon-natural-language-tagging',
};
// Detailed description of the modules listed above.
exports.moduleList = [exports.moduleBc, exports.moduleNlt, exports.moduleOpt];
//# sourceMappingURL=module_list.js.map